// function that adds comma to the prices

export const withComma = (x) => {
  if (x < 1) {
    return x
  }
  if (x > 1000) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return x
}
